import { orchestrator } from 'satcheljs';
import { dropMailItem } from '../actions/dropActions';
import { replyByMeetingService } from 'owa-reply-by-meeting-service';
import { OwaDate, now, startOfHour, addHours, addMinutes } from 'owa-datetime';
import { getDefaultEventDuration } from 'owa-session-store';
import { addPopoutV2 } from 'owa-popout-v2';

const HOURS_IN_ADVANCE = 2;
const CALENDAR_POPOUT_OPTIONS = {
    width: 1095,
    height: 640,
};
const DAY_VIEW_DROP_EVENT_DURATION = 60;

export const dropMailItemOrchestrator = orchestrator(dropMailItem, actionMessage => {
    const { dragData, entryType, preFillStartTime } = actionMessage;
    if (dragData) {
        const referenceItemId = dragData.latestItemIds[0];
        const [startTime, endTime] = getStartEndTime(preFillStartTime);
        const eventIdPromise = replyByMeetingService(
            referenceItemId,
            startTime,
            endTime,
            null,
            null,
            false,
            false
        );

        addPopoutV2(
            'calendar',
            'compose',
            async () => {
                const createdEventId = await eventIdPromise;

                return Promise.resolve(
                    createdEventId
                        ? {
                              draftItemId: createdEventId,
                              extractionSourceId: null,
                              internetMessageId: null,
                              composeEntrySource: entryType,
                          }
                        : null
                );
            },
            CALENDAR_POPOUT_OPTIONS
        );
        Promise.resolve();
    }
});

function getStartEndTime(preFillStartTime?: OwaDate): [OwaDate, OwaDate] {
    const startDate = preFillStartTime
        ? preFillStartTime
        : addHours(startOfHour(now()), HOURS_IN_ADVANCE);
    const endDate = preFillStartTime
        ? addMinutes(startDate, DAY_VIEW_DROP_EVENT_DURATION)
        : addMinutes(startDate, getDefaultEventDuration());
    return [startDate, endDate];
}
